import React, { useState } from 'react';
import './ExerciseSteps.css';

const InfoCarouselStep = ({ step, onContinue }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = step.content;

  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const isLastSlide = currentSlide === slides.length - 1;

  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        
        <div className="carousel-container">
          <div className="carousel-slide">
            <div className="slide-image">
              <img 
                src={slides[currentSlide].image_url} 
                alt={slides[currentSlide].type}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="image-placeholder" style={{ display: 'none' }}>
                {slides[currentSlide].type}
              </div>
            </div>
            <div className="slide-content">
              <h3 className="slide-type">{slides[currentSlide].type}</h3>
              <p className="slide-description">{slides[currentSlide].description}</p>
            </div>
          </div>
          
          <div className="carousel-navigation">
            <button 
              className="nav-button"
              onClick={prevSlide}
              disabled={currentSlide === 0}
            >
              ‹
            </button>
            <div className="slide-indicators">
              {slides.map((_, index) => (
                <span 
                  key={index}
                  className={`indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
            <button 
              className="nav-button"
              onClick={nextSlide}
              disabled={currentSlide === slides.length - 1}
            >
              ›
            </button>
          </div>
        </div>
      </div>
      
      <div className="step-actions">
        {isLastSlide ? (
          <button 
            className="step-button primary"
            onClick={onContinue}
          >
            Continuar
          </button>
        ) : (
          <button 
            className="step-button secondary"
            onClick={nextSlide}
          >
            Siguiente
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoCarouselStep; 